enum CardSchemeId {
  Other = 0,
  Visa = 1,
  MasterCard = 2,
  Maestro = 3,
  AmEx = 4,
  JCB = 5,
  Diners = 6,
  Discover = 7,
  Voyager = 10,
  ChinaUnionPay = 12,
  Cash = 100,
  Debit = 1240,
  Interac = 1241,
  EbtCashBenefit = 1242,
  EbtFoodStamp = 1243,
  SquareGiftCard = 10001,
  SquareEftPos = 10002,
  TCC = 67101,
  LevelUpDiscount = 67102,
  LevelUpGiftCard = 67103,
  LevelUpCreditCard = 67104,
  Givex = 67105,
  Atrium = 67106,
  Archer = 67107,
  PinataStoredValue = 67108,
  Valutec = 67109,
  PaytronixGiftCard = 67110,
  OLOGiftCard = 67111,
  WorldpayGiftCard = 67112,
  FreedomPayGiftCard = 67113,
  EigenGiftCard = 67114,
  ChoptDiscount = 67115,
  ChoptGiftCard = 67116,
  ChoptCreditCard = 67117,
  ComoPointRedemption = 67118,
  Cbord = 67119,
  ThanxReward = 67120,
  ThanxPointRedemption = 67121,
  PunchhCreditCard = 67122,
  PunchhGiftCard = 67123,
  PunchhDiscount = 67124,
  PinataCreditCard = 67125,
  PinataLoyaltyGiftCard = 67126,
  PinataDiscount = 67127,
  ParPayGiftCard = 67128,
  SmoothCommercePayment = 67129,
  SpendgoReward = 67130,
  StarbucksStoredValue = 67131,
  StarbucksInAppPayment = 67132,
  AtriumMealExchange = 67133,
  LovesRewardsPoints = 67134,
  LovesDrinkRefills = 67135,
  PinataCampusCard = 67136,
  Quickcharge = 67137,
  FreedomPayStoredValue = 67138,
  FreedomPayVoucher = 67139,
  AppfrontPayment = 67140,
  TransactCampusCard = 67141,
  AppfrontReward = 67142,
  GivexLoyaltyReward = 67143,
  GivexLoyaltyPayment = 67144,
}

export { CardSchemeId };
